import React from 'react';
import DOMPurify from 'isomorphic-dompurify';
import Script from 'next/script';
import { FAQMarkupScriptProps, FAQMarkupQuery } from './types';

const createFaqJsonLd = (queries: FAQMarkupQuery[]) => ({
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: queries.map(({ question, answer }) => ({
    '@type': 'Question',
    name: question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: answer,
    },
  })),
});

const sanitize = (data: FAQMarkupQuery[]) =>
  DOMPurify.sanitize(JSON.stringify(createFaqJsonLd(data)))
    .replace(/"\\&quot;/, "'")
    .replace(/\\&quot;"/, "'");

const FAQMarkupScript: React.FC<FAQMarkupScriptProps> = ({ queries }) =>
  queries.length ? (
    <Script
      id="faq-markup-script"
      type="application/ld+json"
      dangerouslySetInnerHTML={{
        __html: sanitize(queries),
      }}
    />
  ) : null;

export default FAQMarkupScript;
